import QS from 'qs'

export default {
	install(Vue) {
		let allUrl
		let url = window.location.href.split('#')[0]
		if (!url.includes('elink')) {
			allUrl = `//yue.elianzhixiao.com/`
		} else {
			let port = url.split('?')
			let protial = port[1].split('=')[1]
			if (protial.includes('/')) protial = protial.slice(0, protial.length - 1)
			if (protial.includes('.')) {
				allUrl = `//${protial}/`
			} else {
				allUrl = `//${protial}.elianzhixiao.com/`
			}
			console.info(protial)
		}
		Vue.prototype.baseUrl = allUrl
		Vue.prototype.QS = function(options) {
			return QS.stringify(options)
		}
	}
}
